/* eslint-disable @typescript-eslint/naming-convention */
import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceDataType } from '~core/models/organization.models';
import { humanizeText } from '../utils/utils';

@Pipe({
  name: 'referenceDataType',
  standalone: true
})
export class ReferenceDataTypePipe implements PipeTransform {
  transform(value: ReferenceDataType | string | null | undefined): string {
    if (!value) return '-';

    const mapping: Record<string, string> = {
      electronic_invoicing_application:
        'Application de Facturation Électronique',
      mobile_app: 'Application Mobile',
      fiscal_receipt_terminal: "Terminal d'Émission de Reçus Fiscaux",
      mobile_fiscal_receipt_app: 'Application Mobile de Reçus Fiscaux',
      api: 'API'
    };

    return mapping[value] || humanizeText(value);
  }
}
